import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { CONTACT } from "@/data/site";

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.49s1.07 2.89 1.22 3.09c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35zM12.04 21.5h-.01a9.4 9.4 0 0 1-4.8-1.31l-.34-.2-3.57.94.95-3.48-.22-.36a9.43 9.43 0 1 1 8 4.41zm8.02-17.43A11.27 11.27 0 0 0 12.04.75C5.8.75.72 5.83.72 12.07c0 2 .52 3.94 1.51 5.66L.62 23.25l5.65-1.48a11.3 11.3 0 0 0 5.77 1.47h.01c6.24 0 11.32-5.08 11.32-11.32 0-3.03-1.18-5.87-3.31-8z" />
  </svg>
);

export const FloatingButtons = () => (
  <div className="fixed bottom-5 right-5 z-40 flex flex-col items-center gap-3 sm:bottom-8 sm:right-8">
    <motion.a
      href={CONTACT.instagram}
      target="_blank"
      rel="noreferrer"
      aria-label="Instagram"
      data-testid="floating-instagram-button"
      whileHover={{ scale: 1.1, rotate: -6 }}
      whileTap={{ scale: 0.95 }}
      className="grid h-12 w-12 place-items-center rounded-full border border-white/15 bg-[#111318]/90 text-white backdrop-blur-md"
    >
      <Instagram className="h-5 w-5" />
    </motion.a>
    <motion.a
      href={CONTACT.whatsapp}
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp"
      data-testid="floating-whatsapp-button"
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      className="relative grid h-14 w-14 place-items-center rounded-full bg-[#C8D484] text-black shadow-[0_0_40px_rgba(200,212,132,0.3)]"
    >
      <span className="absolute inset-0 rounded-full bg-[#C8D484] animate-ping-soft" />
      <WhatsAppIcon className="relative h-7 w-7" />
    </motion.a>
  </div>
);
